import { useMutation, useQueryClient } from '@tanstack/react-query';
import { converters as filesConverters } from 'store/files';
import { loaders } from './orders.loaders';
import { ordersKeys } from './orders.queries';

export const useUpdateOrder = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.updateOrder, {
    onSuccess: (_, { orderId }) => {
      return queryClient.invalidateQueries(ordersKeys.detail(orderId));
    },
  });
};

export const useBulkEditOrders = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.bulkEdit, {
    onSuccess: () => {
      return queryClient.invalidateQueries(ordersKeys.all);
    },
  });
};

export const useExportToXls = () => {
  return useMutation(loaders.exportXls, {
    onSuccess: filesConverters.export,
  });
};
